import React, { Component } from 'react'
import { connect } from 'react-redux'

import { actualizarDatosParaMuiTable } from '../actions/TablaDetalleEspacioPorCerealLinea4Actions'
import { TablaDetalleEspacioPorCerealLinea4View } from '../components/TablaDetalleEspacioPorCerealLinea4View'

class TablaDetalleEspacioPorCerealLinea4 extends Component {
  componentDidMount () {
    this.props.actualizarDatosParaMuiTable()
  }

  render () {
    return <TablaDetalleEspacioPorCerealLinea4View />
  }
}

const mapActionsToProps = {
  actualizarDatosParaMuiTable
}
const withRedux = connect(null, mapActionsToProps)

export default withRedux(TablaDetalleEspacioPorCerealLinea4)
